export enum TestStepStatus {
  Pending = 'pending',
  InProgress = 'in-progress',
  Successful = 'successful',
  Failed = 'failed',
}
